import API from './axiosClient';

export const getTimeAndAttendance = (body) => {
  return API.post(`/team/week_entries`, body);
};
